<div class="user-detail-right-main">
<div class="main-profile-image" *ngIf="userData?.profile_image; else skeleton">
  <div 
    class="user-detail-image" 
    
  >
    <img [class.clickable]="!actionView" 
    (click)="!actionView && fileInput.click()" [src]="userData?.profile_image" alt="image missing" />

   

    <div class="user-role-section">
      <p>{{ role_type }}</p>
    </div>
  </div>

   <!-- Edit icon -->
    <span *ngIf="!actionView" [class.clickable]="!actionView" 
    (click)="!actionView && fileInput.click()" class="edit-icon" >
      <svg width="16" height="16" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 3.12132H5.8C4.11984 3.12132 3.27976 3.12132 2.63803 3.4483C2.07354 3.73592 1.6146 4.19486 1.32698 4.75935C1 5.40109 1 6.24116 1 7.92132V16.3213C1 18.0015 1 18.8416 1.32698 19.4833C1.6146 20.0478 2.07354 20.5067 2.63803 20.7943C3.27976 21.1213 4.11984 21.1213 5.8 21.1213H14.2C15.8802 21.1213 16.7202 21.1213 17.362 20.7943C17.9265 20.5067 18.3854 20.0478 18.673 19.4833C19 18.8416 19 18.0015 19 16.3213V12.1213M6.99997 15.1213H8.67452C9.1637 15.1213 9.40829 15.1213 9.63846 15.0661C9.84254 15.0171 10.0376 14.9363 10.2166 14.8266C10.4184 14.7029 10.5914 14.53 10.9373 14.1841L20.5 4.62132C21.3284 3.79289 21.3284 2.44975 20.5 1.62132C19.6716 0.792894 18.3284 0.792893 17.5 1.62132L7.93723 11.1841C7.59133 11.53 7.41838 11.7029 7.29469 11.9048C7.18504 12.0837 7.10423 12.2788 7.05523 12.4829C6.99997 12.713 6.99997 12.9576 6.99997 13.4468V15.1213Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
</div>

<ng-template #skeleton>
  <div 
    class="skeleton profile-image-skeliton" 
    [class.clickable]="!actionView" 
    (click)="!actionView && fileInput.click()"
  >
    <span *ngIf="!actionView" class="edit-icon">
      <!-- Same SVG here if needed -->
    </span>
  </div>
</ng-template>

<input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" hidden />

  <div class="user-detail-top">

    @if (userData?.email) {
    <h1>{{userData?.first_name}}{{userData?.last_name}}</h1>
    } @else {
    <div class="skeleton cmmon-skeliton-width mt-2"></div>
    }
    <div class="comon-field-img">

      @if (userData?.email) {
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.5 5.25L7.62369 9.53658C8.11957 9.8837 8.36751 10.0573 8.6372 10.1245C8.87542 10.1839 9.12458 10.1839 9.3628 10.1245C9.63249 10.0573 9.88043 9.8837 10.3763 9.53658L16.5 5.25M5.1 15H12.9C14.1601 15 14.7902 15 15.2715 14.7548C15.6948 14.539 16.039 14.1948 16.2548 13.7715C16.5 13.2902 16.5 12.6601 16.5 11.4V6.6C16.5 5.33988 16.5 4.70982 16.2548 4.22852C16.039 3.80516 15.6948 3.46095 15.2715 3.24524C14.7902 3 14.1601 3 12.9 3H5.1C3.83988 3 3.20982 3 2.72852 3.24524C2.30516 3.46095 1.96095 3.80516 1.74524 4.22852C1.5 4.70982 1.5 5.33988 1.5 6.6V11.4C1.5 12.6601 1.5 13.2902 1.74524 13.7715C1.96095 14.1948 2.30516 14.539 2.72852 14.7548C3.20982 15 3.83988 15 5.1 15Z"
          stroke="#2D2D2E" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <p>{{userData?.email}}</p>
      } @else {
      <div class="skeleton cmmon-skeliton-width"></div>
      }




    </div>


    <div class="comon-field-img">



      @if (userData) {
      <div class="ids-section">
       <div>
         <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.75 14C2.50184 12.1419 4.88026 11 7.5 11C10.1197 11 12.4982 12.1419 14.25 14M10.875 4.625C10.875 6.48896 9.36396 8 7.5 8C5.63604 8 4.125 6.48896 4.125 4.625C4.125 2.76104 5.63604 1.25 7.5 1.25C9.36396 1.25 10.875 2.76104 10.875 4.625Z"
            stroke="#2D2D2E" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p><strong>Employee ID:</strong>{{userData?.attendance_user_id}}</p>
       </div>
      <div>
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.75 14C2.50184 12.1419 4.88026 11 7.5 11C10.1197 11 12.4982 12.1419 14.25 14M10.875 4.625C10.875 6.48896 9.36396 8 7.5 8C5.63604 8 4.125 6.48896 4.125 4.625C4.125 2.76104 5.63604 1.25 7.5 1.25C9.36396 1.25 10.875 2.76104 10.875 4.625Z"
            stroke="#2D2D2E" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p><strong>ID:</strong>{{userData?.id}}</p>
      </div>
     </div>
      } @else {
      <div class="skeleton cmmon-skeliton-width"></div>
      }



    </div>


  </div>
  <div class="user-detail-three-sec mt-3">
    <div class="row">
      <div class="col-4">
        @if (userData) {
        <div class="three-sect-main">
          <img src="../../../assets/theme1/gender-icon.png" alt="missing icon" />
          <p><span>Gender:</span>{{ userData?.gender | titlecase }}</p>
        </div>
        } @else {
        <div class="skeleton col-skeliton"></div>
        }

      </div>
      <div class="col-4">

        @if (userData) {
        <div class="three-sect-main center-border">
          <img src="../../../assets/theme1/active.png" alt="missing icon" />
          <p><span>Status:</span>{{userData?.employee_status | titlecase}}</p>
        </div>
        } @else {
        <div class="skeleton col-skeliton"></div>
        }

      </div>
      <div class="col-4">
        @if (userData) {
        <div class="three-sect-main">
          <img src="../../../assets/theme1/employee.png" alt="missing icon" />
          <p><span>Role:</span>{{role_type ?? 'Undefined'}}</p>
        </div>
        } @else {
        <div class="skeleton col-skeliton"></div>
        }

      </div>
    </div>
  </div>

  <div class="user-info-section mt-3">






    <div class="user-detail-inner-section">
      @if (userData) {
      <div class="user-detail-inner-img">
        <img src="../../../assets/theme1/date.png" alt="missing icon" />
      </div>
      <div class="user-detail-inner-content">
        <p>
          <span>Joining Date</span>
          {{userData?.joining_date ?? 'Undefined'}}
        </p>
      </div>
      } @else {
      <div class="skeleton"></div>
      }

    </div>

    <div class="user-detail-inner-section">
      @if (userData) {
      <div class="user-detail-inner-img">
        <img src="../../../assets/theme1/cnic.png" alt="missing icon" />
      </div>
      <div class="user-detail-inner-content">
        <p>
          <span>CNIC number</span>
          {{userData?.cnic ?? 'Undefined'}}
        </p>
      </div>
      } @else {
      <div class="skeleton"></div>
      }

    </div>

    <div class="user-detail-inner-section">
      @if (userData) {
      <div class="user-detail-inner-img">
        <img src="../../../assets/theme1/call.png" alt="missing icon" />
      </div>
      <div class="user-detail-inner-content">
        <p>
          <span>Phone number</span>
          {{userData?.phone_number ?? 'Undefined'}}
        </p>
      </div>
      } @else {
      <div class="skeleton"></div>
      }

    </div>

    <div class="user-detail-inner-section">

      @if (userData) {
      <div class="user-detail-inner-img">
        <img src="../../../assets/theme1/spott.png" alt="missing icon" />
      </div>
      <div class="user-detail-inner-content">
        <p>
          <span>Address</span>
          {{userData?.address?.address1 ?? 'Undefined'}}
        </p>
      </div>
      } @else {
      <div class="skeleton"></div>
      }

    </div>

    <div class="user-detail-inner-section no-border">

      @if (userData) {
      <div class="user-detail-inner-img">
        <img src="../../../assets/theme1/department.png" alt="missing icon" />
      </div>
      <div class="user-detail-inner-content">
        <p>
          <span>Department</span>
          {{userData?.department ?? 'Undefined'}}
        </p>
      </div>
      } @else {
      <div class="skeleton"></div>
      }


    </div>
  </div>

</div>

<div class="location-wrapper">
  @if (mapUrl) {
  <div class="map-wrapper">
    <img [src]="mapUrl" alt="Static Map" width="100%" height="300" />
  </div>
  } @else {
  <div class="skeleton full-skeliton"></div>
  }


</div>

<div [ngClass]="{'birthday-wrapper': true, 'no-birthday': !userData?.dob}">
  @if (userData) {
  <h1>Birthday</h1>
  <p>Make Your calendar! Your special day is coming on</p>
  <h1>{{ userData?.dob | date: 'dd MMM' }}
    <img src="../../../assets/theme1/celebration.png" />
  </h1>
  } @else{
  <div class="skeleton full-skeliton"></div>
  }

</div>